import React, { useMemo } from "react";
import "./PracticeByCoursesTricksTab.scss";

// image imports
import CardCourseIcon from "assets/icons/tricksCourseIcon.svg";
import CardDefLeadCourseIcon from "assets/icons/def_lead_courses_exercises.png";
import InteractiveIcon from "assets/images/interactiveBidding.png";
import LockIcon from "assets/images/DeffenceScreenLock-icon.svg";
import ElipseDisabled from "assets/icons/elipseDisabled.svg";

interface Props {
  data?: any;
  onPressItem?: (val: any, type: "interactive-bidding" | "bidding") => void;
  isDefLead?: boolean;
  searchData?: any[];
  searchText?: string;
}

function PracticeByCoursesTricksTab({
  data,
  isDefLead,
  onPressItem,
  searchData,
  searchText
}: Props) {
  const dataTricks = useMemo(() => {
    if (isDefLead) {
      return [];
    }
    if (data?.length > 0) {
      const boofer: any[] = [];
      data?.forEach((val: any) => {
        if (boofer[boofer.length - 1]?.length < 3) {
          boofer[boofer.length - 1] = boofer[boofer.length - 1]
            ? [...boofer[boofer.length - 1], val]
            : [val];
        } else {
          boofer.push([val]);
        }
      });
      return boofer;
    }
  }, [data, isDefLead]);

  if (isDefLead) {
    return (
      <>
        <div className="PracticeByCoursesTricksTab-main">
          <div className="PracticeByCoursesTab-ul">
            <div
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                flex: 1,
                display: "flex"
              }}>
              {data?.map((val: any, index: number) => {
                const isDisabled = typeof val?.isEnabled === "boolean" && !val?.isEnabled;
                return (
                  <div
                    className="list-item-courses"
                    key={`${val?.Id_Course}_${index}_${val?.PageColumn}`}
                    onClick={() =>
                      !isDisabled &&
                      onPressItem &&
                      onPressItem(
                        val,
                        val?.type === "interactive" ? "interactive-bidding" : "bidding"
                      )
                    }>
                    <div className="PracticeByCoursesTab-a">
                      <div className="icon-otr-list-icons-courses-wrapper">
                        {isDisabled ? (
                          <div style={{ position: "relative" }}>
                            <div
                              style={{
                                position: "relative",
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                                background: "none"
                              }}
                              className={"icon-otr list-icons-courses list-icons-courses-disabled"}>
                              <img src={ElipseDisabled} />
                              <img
                                className={`deffence-icon deffence-icon1 ${
                                  val?.type === "interactive" ? "interactive-icon" : ""
                                }`}
                                style={{ position: "absolute", width: 52, height: 62 }}
                                src={LockIcon}
                                alt="icon"
                              />
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="icon-otr-def-lead list-icons-courses">
                              <img
                                className={`deffence-icon deffence-icon1 ${
                                  val?.type === "interactive" ? "interactive-icon" : ""
                                }`}
                                style={{ backgroundSize: "cover" }}
                                src={CardDefLeadCourseIcon}
                                alt="icon"
                              />
                            </div>
                          </>
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flex: 1,
                          width: "100%"
                        }}>
                        <span
                          className="deffence-icon-text"
                          style={{ color: isDisabled ? "rgba(120, 101, 158, 1)" : undefined }}>
                          {isDefLead
                            ? val?.Data?.CourseTitle
                            : `${val?.Title1 || ""} ${val?.Title2 || ""}`}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="PracticeByCoursesTricksTab-main">
        <div className="PracticeByCoursesTab-ul">
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {searchData &&
              searchText &&
              searchText?.length > 0 &&
              searchData.map((val: any, index: number) => {
                const isDisabled = typeof val?.isEnabled === "boolean" && !val?.isEnabled;
                return (
                  <div
                    className="list-item-courses"
                    key={`${val?.Id_Course}_${index}_${val?.PageColumn}`}
                    onClick={() =>
                      !isDisabled &&
                      onPressItem &&
                      onPressItem(
                        val,
                        val?.type === "interactive" ? "interactive-bidding" : "bidding"
                      )
                    }>
                    <div className="PracticeByCoursesTab-a">
                      {isDisabled ? (
                        <div style={{ position: "relative" }}>
                          <div
                            style={{
                              position: "relative",
                              justifyContent: "center",
                              alignItems: "center",
                              display: "flex",
                              background: "none"
                            }}
                            className={"icon-otr list-icons-courses list-icons-courses-disabled"}>
                            <img src={ElipseDisabled} />
                            <img
                              className={`deffence-icon deffence-icon1 ${
                                val?.type === "interactive" ? "interactive-icon" : ""
                              }`}
                              style={{ position: "absolute", width: 52, height: 62 }}
                              src={LockIcon}
                              alt="icon"
                            />
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="icon-otr-tricks">
                            <img
                              className={`deffence-icon deffence-icon1 ${
                                val?.type === "interactive" ? "interactive-icon" : ""
                              }`}
                              src={val?.type === "interactive" ? InteractiveIcon : CardCourseIcon}
                              alt="icon"
                            />
                            <img
                              className="deffence-icon deffence-icon2"
                              src={LockIcon}
                              alt="icon"
                            />
                          </div>
                        </>
                      )}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flex: 1,
                          width: "100%"
                        }}>
                        <span
                          className="deffence-icon-text"
                          style={{
                            color: isDisabled ? "rgba(120, 101, 158, 1)" : undefined
                          }}>
                          {isDefLead
                            ? val?.Data?.CourseTitle
                            : `${val?.Title1 || ""} ${val?.Title2 || ""}`}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="PracticeByCoursesTab-ul-wrap"
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              flex: 1,
              display: "flex",
              paddingLeft: "20px"
            }}>
            {searchText?.length === 0 &&
              dataTricks &&
              dataTricks?.map((item: any[], index_item: number) => {
                return (
                  <div
                    key={index_item}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                      paddingLeft: 10
                    }}>
                    {item.map((val: any, index: number) => {
                      const isDisabled = typeof val?.isEnabled === "boolean" && !val?.isEnabled;
                      return (
                        <div
                          className="list-item-courses"
                          key={`${val?.Id_Course}_${index}_${val?.PageColumn}`}
                          onClick={() =>
                            !isDisabled &&
                            onPressItem &&
                            onPressItem(
                              val,
                              val?.type === "interactive" ? "interactive-bidding" : "bidding"
                            )
                          }
                          style={{ width: "100%" }}>
                          <div className="PracticeByCoursesTab-a">
                            <div className="icon-otr-list-icons-courses-wrapper">
                              {isDisabled ? (
                                <div style={{ position: "relative" }}>
                                  <div
                                    style={{
                                      position: "relative",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      background: "none"
                                    }}
                                    className={
                                      "icon-otr list-icons-courses list-icons-courses-disabled"
                                    }>
                                    <img src={ElipseDisabled} />
                                    <img
                                      className={`deffence-icon deffence-icon1 ${
                                        val?.type === "interactive" ? "interactive-icon" : ""
                                      }`}
                                      style={{ position: "absolute", width: 52, height: 62 }}
                                      src={isDisabled ? LockIcon : CardCourseIcon}
                                      alt="icon"
                                    />
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <div className="icon-otr-tricks">
                                    <img
                                      className={`deffence-icon deffence-icon1 ${
                                        val?.type === "interactive" ? "interactive-icon" : ""
                                      }`}
                                      src={
                                        val?.type === "interactive"
                                          ? InteractiveIcon
                                          : CardCourseIcon
                                      }
                                      alt="icon"
                                    />
                                    <img
                                      className="deffence-icon deffence-icon2"
                                      src={LockIcon}
                                      alt="icon"
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                flex: 1,
                                width: "100%"
                              }}>
                              <span
                                className="deffence-icon-text"
                                style={{
                                  color: isDisabled ? "rgba(120, 101, 158, 1)" : undefined
                                }}>
                                {isDefLead
                                  ? val?.Data?.CourseTitle
                                  : `${val?.Title1 || ""} ${val?.Title2 || ""}`}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
}

export default PracticeByCoursesTricksTab;
